import type { Update } from '@tauri-apps/plugin-updater';

export const OTA_UPDATE_POLL_INTERVAL_MS = 60 * 1000;

export const isReleaseMetadataMissingError = (error: unknown): boolean => {
  const message = String(error);
  return message.includes('Could not fetch a valid release JSON');
};

export const disposeUpdate = async (
  update: Update | null | undefined,
  context: string
) => {
  if (!update) {
    return;
  }

  try {
    await update.close();
  } catch (error) {
    console.error(`Error closing updater handle during ${context}:`, error);
  }
};
